import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
};

export const TYPE = {
    ASSOCIATION: 'association',
    COMPANY: 'company',
    DIVISION: 'division',
    OFFICE: 'office',
    BRANCH: 'branch',
    TEAM: 'team',
    GROUP: 'group',
    SELF: 'self',
    OTHER: 'other',
};

class PublicOrganizationAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Public-Organization';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'organizations/public';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'owner_user_uuid',
            'parent_organization_uuid',
            'status',
            'ownerUser',
            'parentOrganization',
            'files',
            'propertyInstances',
            'workspaces',
            'workspaceTypes',
            'stageTypes',
            'stageRoles',
            'childrenOrganizations',
            'members',
            'users',
            'contacts',
            'tasks',
            'taskCategories',
            'taskPriorities',
            'taskStatuses',
            'taskRoles',
            'calendarCategories',
            'calendars',
            'calendarEventCategories',
            'calendarEvents',
            'emails',
            'phones',
            'addresses',
            'userInvitations',
            'properties',
            'taskLists',
            'is_system',
            'resources',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'type',
            'name',
            'description',
            'branding',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {};
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            ownerUser: 'owner_user_uuid',
            parentOrganization: 'parent_organization_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {};
    }
}

export default PublicOrganizationAppResource;
